import { createContext } from 'react';

const StepperContext = createContext();

export default StepperContext;
